import React from "react";
import styled from "styled-components";
import BasicPageTemplate from "./BasicPageTemplate";
import Wrapper from "../atoms/Wrapper";
import H1 from "../atoms/H1";

const StyledH1 = styled(H1)`
  margin-top: 6rem;
  margin-bottom: 7rem;
  line-height: 3rem;

  @media (max-width: 760px) {
    margin-top: 5rem;
    margin-bottom: 6rem;
  }
`;

const TitleWrapper = styled(Wrapper)`
  width: 100%;
  background: ${props => props.theme.colors.gray100};
  color: ${props => props.theme.colors.black};
  margin-bottom: 3rem;
  padding: 0 1rem;
  box-sizing: border-box;
  box-shadow: inset 0 -2px 4px ${props => props.theme.colors.shadow};
`;

const StyledArticle = styled.article`
  line-height: 2.7rem;
  width: ${props => (props.fullWidth ? "calc(100% - 2rem)" : "48rem")};
  max-width: calc(100% - 2rem);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 3rem;
`;

export default props => (
  <BasicPageTemplate leftDrawerOpen={props.leftDrawerOpen}>
    <TitleWrapper>
      <StyledH1>{props.title}</StyledH1>
    </TitleWrapper>
    <StyledArticle fullWidth={props.fullWidth}>{props.children}</StyledArticle>
  </BasicPageTemplate>
);
